// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avatar-editor-container {
  padding-bottom: var(--input-element-gap);
}

.avatar-editor-avatar-preview-container {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
}

.avatar-editor-container .select-container {
  min-width: 250px;
}

.avatar-editor-avatar-preview-checkbox {
  position: absolute;
  bottom: 0;
  right: var(--input-element-gap);
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/avatar-editor/AvatarEditor.component.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,+BAA+B;AACjC","sourcesContent":[".avatar-editor-container {\n  padding-bottom: var(--input-element-gap);\n}\n\n.avatar-editor-avatar-preview-container {\n  width: 100%;\n  height: 200px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.avatar-editor-container .select-container {\n  min-width: 250px;\n}\n\n.avatar-editor-avatar-preview-checkbox {\n  position: absolute;\n  bottom: 0;\n  right: var(--input-element-gap);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
